import { Helmet } from 'react-helmet';
import { Outlet } from 'react-router-dom';
import { MainContainer } from 'src/components';

function SphereLayout() {
  return (
    <MainContainer>
      <Helmet>
        <title>sphere | cyb</title>
      </Helmet>

      <Outlet />
    </MainContainer>
  );
}

export default SphereLayout;
